import { type ButtonHTMLAttributes, forwardRef } from 'react';
import { cn } from '../utils';

export const headerIconAffordanceClassName = cn(
  'inline-flex items-center justify-center rounded-full p-2 text-white transition-colors hover:bg-white/10',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring-on-dark',
);

export interface HeaderIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  'aria-label': string;
}

export const HeaderIconButton = forwardRef<HTMLButtonElement, HeaderIconButtonProps>(({ className, children, ...props }, ref) => {
  return (
    <button ref={ref} type="button" className={cn(headerIconAffordanceClassName, 'cursor-pointer', className)} {...props}>
      {children}
    </button>
  );
});

HeaderIconButton.displayName = 'HeaderIconButton';
